import styled from 'styled-components';

export const CalendarDiv = styled.div``;

export const DaysOfWeekColumn = styled.div`
  display: flex;
  padding: 0;
`;

export const MenuItemContainer = styled.div<{
  dayOfWeekString: string;
  localDaysOfWeek: string[];
}>`
  > li {
    ${(props: any) =>
      `color: ${
        props.localDaysOfWeek.includes(props.dayOfWeekString) ? 'green' : ''
      };`}
    ${(props: any) =>
      `font-weight: ${
        props.localDaysOfWeek.includes(props.dayOfWeekString)
          ? 'bold'
          : 'normal'
      };`}
      font-size: .9rem;
    margin: 0;
  }
`;
